import React from 'react';
import styled from 'styled-components';
import Fragment from 'react-dot-fragment';
import InfoIcon from '../../containers/assets/info-alert.png';
import SuccessIcon from '../../containers/assets/success-alert.png';
import ErrorIcon from '../../containers/assets/error-alert.png';
import WarningIcon from '../../containers/assets/warning-icon-2.png';

const AlertOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #000;
  opacity: 0.4;
  z-index: 2001;

  ${p => p.overlayStylings && `
    ${p.overlayStylings}
  `}
`;

const AlertWrapper = styled.div`
  background: #ffffff;
  width: 100%;
  max-width: ${p => p.size === 'lg' ? '800px' : '400px'};
  position: fixed;
  z-index: 2002;
  top: ${p => p.size === 'lg' ? '180px' : '300px'};
  left: 50%;
  margin-left: ${p => p.size === 'lg' ? '-400px' : '-200px'};

  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.08), 0px 10px 16px rgba(0, 0, 0, 0.1);
  border-radius: ${p => p.size === 'lg' ? '16px' : '8px'};
  padding: ${p => p.size === 'lg' ? '56px 56px 40px' : '32px 32px 24px'};

  /* Subtle celebration accent for the lg variant so the last-of-four
     post message reads differently from a routine success toast. */
  ${p => p.size === 'lg' && `
    background:
      radial-gradient(120% 60% at 50% 0%, rgba(82, 197, 205, 0.14) 0%, rgba(82, 197, 205, 0) 60%),
      #ffffff;
    border: 1px solid rgba(82, 197, 205, 0.35);
  `}

  ${p => p.modalStylings && `
    ${p.modalStylings}
  `}
`;

const AlertTitle = styled.div`
  font-family: 'Mukta Vaani';
  font-weight: 700;
  font-size: ${p => p.size === 'lg' ? '20px' : '18px'};
  line-height: ${p => p.size === 'lg' ? '28px' : '24px'};
  color: rgba(0, 27, 59, 0.94);
`;

const AlertMessage = styled.div`
  font-family: 'Mukta Vaani';
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.94);
  margin-top: 8px;

  ul {
    list-style: disc;
    padding-left: 30px;
  }
  
  ul li {
    font-size: 16px !important;
    line-height: 24px !important;
    margin-top: 3px;
  }
`;

const AlertButton = styled.div`
  background: #5c91f5;
  display: inline-block;
  float: right;
  cursor: pointer;
  margin-top: 24px;
  border: 1.5px solid #5c91f5;
  padding: 6px 14px;
  border-radius: 4px;

  font-family: 'Mukta Vaani';
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #ffffff;
  align-self: flex-end;

  ${p => p.alignCenter && `
    align-self: center;
  `}
`;

const AlertBody = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${p => p.size === 'lg' ? '24px' : '16px'};
  align-items: flex-start;
  justify-content: flex-start;
`;

const IconSlot = styled.div`
  flex-shrink: 0;

  img {
    ${p => p.size === 'lg' && `
      width: 56px;
      height: 56px;
    `}
  }
`;

const FullWidth = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const LargeButton = styled(AlertButton)`
  padding: 10px 22px;
  font-size: 15px;
  line-height: 22px;
  margin-top: 32px;
`;

const DecisionsAlert = ({
  title,
  message,
  onHide,
  type,
  buttonText = 'Got it',
  buttonCenterAlign = false,
  overlayStylings = null,
  modalStylings = null,
  size = 'md'
}) => {
  const ButtonComponent = size === 'lg' ? LargeButton : AlertButton;
  return (
    <Fragment>
      <AlertOverlay overlayStylings={overlayStylings} />
      <AlertWrapper size={size} modalStylings={modalStylings}>
        <AlertBody size={size}>
          {type === 'info' && <IconSlot size={size}><img src={InfoIcon} alt="" /></IconSlot>}
          {type === 'success' && <IconSlot size={size}><img src={SuccessIcon} alt="" /></IconSlot>}
          {type === 'error' && <IconSlot size={size}><img src={ErrorIcon} alt="" /></IconSlot>}
          {type === 'warning' && <IconSlot size={size}><img src={WarningIcon} alt="" /></IconSlot>}
          <FullWidth>
            <AlertTitle size={size}>{title}</AlertTitle>
            <AlertMessage>{message}</AlertMessage>
            <ButtonComponent onClick={onHide} alignCenter={buttonCenterAlign}>{buttonText}</ButtonComponent>
          </FullWidth>
        </AlertBody>
      </AlertWrapper>
    </Fragment>
  );
};

export default DecisionsAlert;



// WEBPACK FOOTER //
// ./src/components/alerts/decisions.js